module.exports = __webpack_public_path__ + "img/paci_en_6.7e21922d.png";